import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const JudgeRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#05339c] flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-yellow"></div>
      </div>
    );
  }

  // Check if user is authenticated and is the judge
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children || <Outlet />;
};

export default JudgeRoute;

